import React, { useState } from 'react';
import { History } from 'lucide-react';

import { Button } from '../ui/button.jsx';
import { Tooltip } from '../ui/tooltip.jsx';
import RecordHistoryDrawer from './RecordHistoryDrawer';

/**
 * The History button in a record's header — the quote request page, and the
 * customer, vehicle, organisation, fleet vehicle and booking dialogs. An icon
 * with its label in the tooltip, like "Get support" in PageHeaderActions.
 *
 * Render it for a saved record only: a record being created has no history.
 */
export default function RecordHistoryButton({ rowId, title, className = '' }) {
  const [open, setOpen] = useState(false);
  if (!rowId) return null;

  return (
    <>
      <Tooltip content="Change history">
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label="Change history"
          className={className}
          onClick={() => setOpen(true)}
        >
          <History className="h-5 w-5" />
        </Button>
      </Tooltip>
      <RecordHistoryDrawer open={open} onOpenChange={setOpen} rowId={rowId} title={title} />
    </>
  );
}
